import { ReactElement } from 'react';
import { Trans } from '@lingui/macro';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';

type TSubheadings = {
  required: string | ReactElement;
  processing: string | ReactElement;
  complete: string | ReactElement;
};

const brokerChannelSubheadings: TSubheadings = {
  required: (
    <Trans>
      To continue the application, please upload documents to any required
      section.
    </Trans>
  ),
  processing: (
    <Trans>
      We're currently processing your documents. We will get back to you in 24
      hours if you need to upload any more documents.
    </Trans>
  ),
  complete: (
    <Trans>You've successfully provided all the required documents.</Trans>
  ),
};

const partnerChannelSubheadings: TSubheadings = {
  required: 'More documents are required from the customer.',
  processing: "We're currently processing the customer's documents.",
  complete:
    'The customer has successfully provided all the required documents.',
};

export const renderSubheading = (
  documentRequirements?: TOfferDataRequirement['actions'],
  isPartnerChannel: boolean = false,
) => {
  if (!documentRequirements) {
    return null;
  }
  const hasRequired = documentRequirements?.find((requirement) => {
    return (
      (requirement.status === 'required' || requirement.status === 'error') &&
      !requirement.is_optional
    );
  });

  const hasProcessing = documentRequirements?.find((requirement) => {
    return (
      !hasRequired &&
      requirement.status === 'pending' &&
      !requirement.is_optional
    );
  });

  const subheadings = isPartnerChannel
    ? partnerChannelSubheadings
    : brokerChannelSubheadings;

  if (hasRequired) {
    return subheadings.required;
  }
  if (hasProcessing) {
    return subheadings.processing;
  }
  return subheadings.complete;
};
